var path = '/components/state-manager/filter-field/types/datetimeexact.tpl.html';
var html = "<div>\n    <customfield ng-model=\"vm.model.min\" definition=\"vm.options\"></customfield>\n    to\n    <customfield ng-model=\"vm.model.max\" definition=\"vm.options\"></customfield>\n</div>\n\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/state-manager/filter-field/types/datetimeexact.tpl.html
// module id = 2021
// module chunks = 1